import { groupBy, orderBy, toArray } from "lodash";

import { useMemo } from "react";

const processProjectDateMessages = (
    messageByProject,
    project,
    employeesToUpdate,
    groupIndex,
    employeeIndex,
    clientIndex,
    projectIndex
) => {
    const dateMessages = toArray(
        groupBy(messageByProject, (message) => message["Date"])
    );

    dateMessages.forEach((messagesByDate) => {
        const date = messagesByDate[0].Date;
        const dateIndex = project.allocations.findIndex(
            (allocation) => allocation.date === date
        );

        if (dateIndex > -1) {
            const latestMessage = orderBy(messagesByDate, "UpdateOn", "desc")[0];
            employeesToUpdate[groupIndex][employeeIndex].summary[dateIndex].allocatedHours =
                latestMessage.TotalAllocatedSummary;
            employeesToUpdate[groupIndex][employeeIndex].details[clientIndex].projects[projectIndex].allocations[dateIndex].value =
                latestMessage.Hours;
        }
    });
};

const processEmployeeDetail = (
    messagesToProcess,
    employeesToUpdate,
    groupIndex,
    employeeIndex
) => {
    const projectMessages = toArray(
        groupBy(messagesToProcess, (message) => message["JobId"])
    );

    projectMessages.forEach((messageByProject) => {
        const jobId = messageByProject[0].JobId;
        const details = [
            ...employeesToUpdate[groupIndex][employeeIndex].details,
        ];

        details.forEach((client, clientIndex) => {
            const projectIndex = client.projects.findIndex(
                (project) => project.jobId === jobId
            );

            if (projectIndex > -1) {
                const project = { ...details[clientIndex].projects[projectIndex] };
                processProjectDateMessages(
                    messageByProject,
                    project,
                    employeesToUpdate,
                    groupIndex,
                    employeeIndex,
                    clientIndex,
                    projectIndex
                );
            }
        });
    });
};

const processEmployyeSummary = (
    messagesToProcess,
    employeesToUpdate,
    groupIndex,
    employeeIndex
) => {
    let summaryCopy = [
        ...employeesToUpdate[groupIndex][employeeIndex].summary,
    ];

    let dateIndex;

    const dateMessages = toArray(
        groupBy(messagesToProcess, (message) => message["Date"])
    );

    dateMessages.forEach((messagesByDate) => {
        const date = messagesByDate[0].Date;

        dateIndex = summaryCopy.findIndex(
            (allocation) => allocation.date === date
        );

        if (dateIndex > -1) {
            const latestMessage = orderBy(
                messagesByDate,
                "UpdateOn",
                "desc"
            )[0];

            employeesToUpdate[groupIndex][employeeIndex].summary[
                dateIndex
            ].allocatedHours = latestMessage.TotalAllocatedSummary;
        }
    });
};

const processMessagesQueue = (employeesToUpdate, messagesToProcess) => {
    let updatedEmployees = [...employeesToUpdate];

    if (
        updatedEmployees &&
        updatedEmployees.length > 0 &&
        messagesToProcess &&
        messagesToProcess.length > 0
    ) {
        let messagesCopy = [...messagesToProcess];
        const messagesByUser = toArray(
            groupBy(messagesCopy, (message) => message["UserId"])
        );
        let groupIndex;
        let employeeIndex;

        messagesByUser.forEach((messagesByUser) => {
            const userId = messagesByUser[0].UserId;
            const titleId = messagesByUser[0].TitleId;
            const officeId = messagesByUser[0].OfficeId;

            updatedEmployees.forEach((group, index) => {
                groupIndex = index;
                employeeIndex = group.findIndex(
                    (employee) =>
                        employee.id === userId &&
                        employee.titleId === titleId &&
                        employee.locationId === officeId
                );
            });

            const employee = updatedEmployees[groupIndex][employeeIndex];

            if (employee) {
                if (employee.details) {
                    processEmployeeDetail(
                        messagesByUser,
                        updatedEmployees,
                        groupIndex,
                        employeeIndex
                    );
                } else {
                    processEmployyeSummary(
                        messagesByUser,
                        updatedEmployees,
                        groupIndex,
                        employeeIndex
                    );
                }
            }
        });
    }
    return updatedEmployees;
};

export const useAllocationsMessages = () => {
    const methods = useMemo(() => {
        return { processMessagesQueue };
    }, []);

    return methods;
};
